import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import ReferencesPageTemplate from '../components/ReferencesPageTemplate'
import Layout from '../components/Layout'

const ReferencesPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <ReferencesPageTemplate
        title={frontmatter.title}
        meta_title={frontmatter.meta_title}
        meta_description={frontmatter.meta_description}
        references={frontmatter.references}
      />
    </Layout>
  )
}

ReferencesPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default ReferencesPage

export const referencesPageQuery = graphql`
  query ReferencesPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        meta_title
        meta_description
        references {
          heading
          description
          items_left {
            title
          }
          items_right {
            title
          }
          description_right
        }
      }
    }
  }
`
